import "./Portfolio.scss";
import Header from "../../components/Layout/Header/Header";
import Footer from "../../components/Layout/Footer/Footer";

function Portfolio() {
  return (
    <>
      <Header />
      <div>hello world</div>
      <Footer />
    </>
  );
}

export default Portfolio;
